import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Text, useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import idCardBack from '../../assets/images/personalIdInfoLayer/id-card-back.png';
import passportFront from '../../assets/images/personalIdInfoLayer/passport-front.png';
import { NextImage } from '../../components/internal/NextImage/index.js';
import { ContentLayer, ContentLayerBody, Flex } from '../../primitives/index.js';
export const PersonalIdInfoLayer = ({
  open,
  onClose
}) => {
  const {
    t
  } = useTranslation('personalIdInfoLayer');
  const mdUp = useBreakpointUp('md');
  return _jsx(ContentLayer, {
    title: t('reisedokument'),
    visuallyHideTitle: mdUp,
    css: /*#__PURE__*/css("&&{width:", mdUp ? '560px' : '', ";padding-top:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    open: open,
    onClose: onClose,
    closeButtonLabel: t('closeButton'),
    children: _jsx(ContentLayerBody, {
      style: {
        paddingTop: mdUp ? 0 : '20px'
      },
      children: _jsxs(Flex, {
        children: [_jsx(Text, {
          preset: "headlineLarge",
          children: t('header')
        }), _jsxs(Flex, {
          direction: mdUp ? 'row' : 'column',
          children: [_jsxs(Flex, {
            gap: 0,
            justifyContent: "center",
            maxWidth: 256,
            children: [_jsx(Text, {
              preset: "headlineSmall",
              children: t('passportHeadline')
            }), _jsx(Text, {
              preset: "paragraphMedium",
              children: t('passportDetails')
            })]
          }), _jsx(NextImage, {
            width: 228,
            height: 157,
            image: passportFront
          })]
        }), _jsxs(Flex, {
          direction: mdUp ? 'row' : 'column',
          children: [_jsxs(Flex, {
            gap: 0,
            justifyContent: "center",
            maxWidth: 256,
            children: [_jsx(Text, {
              preset: "headlineSmall",
              children: t('idCardHeadline')
            }), _jsx(Text, {
              preset: "paragraphMedium",
              children: t('idCardDetails')
            })]
          }), _jsx(NextImage, {
            width: 228,
            height: 157,
            image: idCardBack
          })]
        })]
      })
    })
  });
};